import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { DrilldownContent } from '../../../components/attack-events-grid/drilldown-panel/drilldown-content'

const ReactAttackEventDrilldown = ({ organizationId, eventUuid }) => {
  return (
    <DrilldownContent
      layout="page"
      organizationID={organizationId}
      eventUuid={eventUuid}
    />
  )
}

export const reactAttackEventDrilldown = createNgReactBridgeDirective(
  'reactAttackEventDrilldown',
  [],
  ReactAttackEventDrilldown,
  ['organizationId', 'eventUuid']
)
